import React from 'react';
import Select from 'react-select';

import styles from './pollQuestionStyles.scss';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';

import { labelize } from 'buyside/util/arrayHelper';

class PollQuestion extends React.Component {
  constructor() {
    super();
    this.state = {
      submitting: false,
      error: false,
      answers: []
    };
    this.updateAnswers = this.updateAnswers.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  updateAnswers(e, isCheckbox) {
    if (isCheckbox) {
      const newAnswers = e.target.checked
        ? this.state.answers.concat(e.target.value)
        : this.state.answers.filter(answer => answer !== e.target.value);
      this.setState({ answers: newAnswers });
    } else {
      this.setState({ answers: [e.target.value] });
    }
  }

  submitForm(e) {
    e.preventDefault();
    this.setState({ submitting: true });
    this.props.handleAnswer(this.props.question.id, this.state.answers);
    this.setState({ submitting: false });
  }

  render() {
    const { minNum, maxNum, incrementNum, numPlaceholder } = this.props;
    const { id, text, answerOptions, questionType } = this.props.question;
    const isText = questionType === 'text';
    const isCheckbox = questionType === 'multi';
    const isNumber = questionType === 'number';
    const isSelect = !isCheckbox && answerOptions.length > 5;
    const selectAnswerOptions = isSelect ? labelize(answerOptions) : null;

    return (
      <form onSubmit={this.submitForm}>
        <div className={styles.pollQuestionText}>
          <div>{text}</div>
        </div>
        <div className={styles.pollAnswers}>
          {isText && (
            <input
              type="text"
              className={styles.inputTextField}
              onChange={this.updateAnswers}
              placeholder="Enter your answer"
            />
          )}
          {isNumber && (
            <input
              type="number"
              min={minNum || -200}
              max={maxNum || 200}
              step={incrementNum || 0.1}
              className={styles.inputTextField}
              onChange={this.updateAnswers}
              placeholder={numPlaceholder || 'Enter a value between -200 and 200'}
            />
          )}
          {!isText &&
            !isNumber &&
            (isSelect ? (
              <Select
                menuShouldScrollIntoView={false}
                value={selectAnswerOptions.filter(option => option.value === this.state.answers[0])}
                onChange={selectedOption => {
                  if (selectedOption) {
                    this.updateAnswers({ target: { value: selectedOption.value } });
                  }
                }}
                options={selectAnswerOptions}
              />
            ) : (
              answerOptions.map((answer, idx) => {
                return (
                  <label key={idx} className={styles.radioOption}>
                    <input
                      type={isCheckbox ? 'checkbox' : 'radio'}
                      name="pollQuestion"
                      value={answer}
                      checked={this.state.answers.includes(answer)}
                      onChange={e => this.updateAnswers(e, isCheckbox)}
                    />
                    <span>{answer}</span>
                  </label>
                );
              })
            ))}
        </div>
        <div className={styles.submitButtonWrap}>
          <Button
            text={this.state.submitting ? 'Submitting...' : 'Submit Response'}
            disabled={!this.state.answers.filter(answer => answer).length}
            isLoading={this.state.submitting}
            type={BUTTON_TYPES.PRIMARY}
            size={BUTTON_SIZES.SMALL}
            analyticsTag={`buyside-poll-submit-${id}`}
          />
          {this.props.handleSkip && (
            <Button
              text="Skip Question"
              onClick={() => this.props.handleSkip(id)}
              isLoading={this.state.submitting}
              type={BUTTON_TYPES.LINK}
              buttonType={BUTTON_TYPES.BUTTON}
              analyticsTag={`buyside-poll-skip-${id}`}
            />
          )}
        </div>
      </form>
    );
  }
}

export default PollQuestion;
